import { render } from "./testSwiperLightBox.vue?vue&type=template&id=cdceb3ac"
import script from "./testSwiperLightBox.vue?vue&type=script&lang=js"
export * from "./testSwiperLightBox.vue?vue&type=script&lang=js"

import "./testSwiperLightBox.vue?vue&type=style&index=0&id=cdceb3ac&lang=css"

import exportComponent from "/var/www/turkey-25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__